import { ProfileMutationTypes } from './types';

export const mutations = {
    [ProfileMutationTypes.SetProfile](state, {profile}) {
        return state.profile = profile
    },
}